import { Record, List, Set } from 'immutable';

const defaultRecordValues = (role) => ({
  admin: null,
  pic: null,
  id: null,
  email: null,
  first_name: null,
  last_name: null,
  display_name: null,
  display_role: null,
  phone: '',
  role,
  title: '',
  companies_id: new Set(),
  restricted: false,
  limited: false,
  readonly: false,
  vat_id: null,
});

const defaultEnhancedRecordValues = {
  ...defaultRecordValues('accountant'),
  assigned: false,
  assignedCount: 0,
};

export const UserFactory = new Record(defaultRecordValues('accountant'));

// eslint-disable-next-line max-len
export const EnhancedUserFactory = new Record(defaultEnhancedRecordValues);

export function singleUserAdapter(rawUser) {
  const user = {
    ...rawUser,
    phone: rawUser.phone || '',
    companies_id: Set(rawUser.companies_id),
    pic: rawUser.picture,
  };
  return UserFactory(user);
}

export function UserAdapter(data) {
  return List(data.map(singleUserAdapter));
}
